// extracted by mini-css-extract-plugin
export default {"container":"lB6AtB7r3i_bxYS"};